import { BaseEntity, Entity as DecribeEntity, RelationList } from '@avangard/utils/entity';

import { LapEntity, LapEntityList } from '@modules/lap/entities';

import type { StudentPublicInfo } from '@modules/types/graphql';

export type Raw = StudentPublicInfo | null;

@DecribeEntity('StudentPublicInfoEntity')
class StudentPublicInfoEntity extends BaseEntity {
    id: string;
    studentName: string;
    schoolName: string;
    locationName: string;

    @RelationList(() => LapEntityList)
    laps: LapEntity[];

    constructor(entity: Raw) {
        super(entity);

        this.id = entity?.id ?? '';
        this.studentName = entity?.studentName ?? '';
        this.schoolName = entity?.schoolName ?? '';
        this.locationName = entity?.locationName ?? '';
    }

    hasLaps() {
        return this.laps.length > 0;
    }
}

export { StudentPublicInfoEntity };
